import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const fetchAdvisories = async (query) => {
    const result = await apiClient.get(`${ENDPOINTS.advisories}?${query}`);
    return result?.data;
};

export const useFetchAdvisories = ({ query, isEnabled = true, ...options } = {}) => {
    const { data, isFetched, ...rest } = useQuery({
        queryKey: queryKeys.advisories(query),
        queryFn: () => fetchAdvisories(query),
        enabled: isEnabled,
        refetchOnMount: false,
        ...options,
    });

    return { data, isFetched, ...rest };
};
